import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { useCustomAnalytics } from '~/hooks/utils/customAnalytics';
const CollectionLink = ({ title, slug, children, locationDetail, sx, ...props }) => {
  const { trackClickCollection } = useCustomAnalytics();

  const url = `/${slug}/`;

  /* 
{
    "brand": "omorpho",
    "title": "Shop Mens",
    "collection_id": "/mens/",
    "url": "http://localhostmens"
}
*/

  return (
    <Link
      to={url}
      aria-label={`Shop ${slug} gear`}
      onClick={() => trackClickCollection({ title, slug, url, locationDetail })}
      sx={{
        ...sx,
      }}
      {...props}
    >
      {children}
    </Link>
  );
};

CollectionLink.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  children: PropTypes.node,
};

export default CollectionLink;
